import { SectionType } from "./types";

const SECTION_KEYWORDS: Array<[SectionType, string[]]> = [
  ["lab_proof", ["lab", "third party", "third-party", "heavy metal", "certificate", "coa", "fulvic"]],
  ["comparison", ["compare", "generic", "copy", "fake", "resin", "gummies"]],
  ["faq", ["faq", "question", "questions"]],
  ["reviews", ["review", "testimonial", "customer"]],
  ["best_sellers", ["best seller", "best-selling", "shop our"]],
  ["buy_box", ["add to cart", "buy now"]],
];

export function detectVisibleSectionType(target: Element): SectionType {
  const text = target.textContent?.toLowerCase().slice(0, 1200) ?? "";

  for (const [type, keywords] of SECTION_KEYWORDS) {
    if (keywords.some((keyword) => text.includes(keyword))) return type;
  }

  return "unknown";
}

export function observeSections(onSeen: (sectionType: SectionType) => void): () => void {
  const candidates = Array.from(document.querySelectorAll("section, [id], .shopify-section, main > div"));
  if (typeof IntersectionObserver === "undefined") {
    candidates.forEach((element) => {
      const sectionType = detectVisibleSectionType(element);
      if (sectionType !== "unknown") onSeen(sectionType);
    });
    return () => undefined;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const sectionType = detectVisibleSectionType(entry.target);
          if (sectionType !== "unknown") onSeen(sectionType);
        }
      }
    },
    { threshold: 0.35 },
  );

  candidates.forEach((element) => observer.observe(element));
  return () => observer.disconnect();
}
